import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeader from "@/components/feature/SectionHeader";
import RankingList from "@/pages/home/components/RankingList";
import { allVideos } from "@/lib/videoData";

const featured = [...allVideos].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function FeaturedSection() {
  return (
    <section className="mt-10 border-y border-background-200/80 bg-background-50 py-10 md:mt-14 md:py-14">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-8">
        <SectionHeader
          title="精选推荐"
          subtitle="编辑团队按口碑与热度人工挑选，优先呈现高分内容"
          icon="ri-award-line"
          moreTo="/category/movie"
          moreLabel="浏览全部片库"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_300px] lg:gap-7">
          <div>
            <div className="grid grid-cols-2 gap-3.5 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4">
              {featured.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>

            <div className="mt-6 flex flex-col items-start justify-between gap-3 rounded-lg border border-dashed border-primary-200 bg-primary-50/50 px-4 py-4 sm:flex-row sm:items-center">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-800 text-accent-300">
                  <i className="ri-movie-2-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">没找到想看的类型？</p>
                  <p className="mt-0.5 text-[11px] text-foreground-600">
                    按地区、年份与热度筛选，30 部精选内容随时可查。
                  </p>
                </div>
              </div>
              <Link
                to="/search"
                className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md bg-primary-800 px-4 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-900"
              >
                进入搜索
                <i className="ri-search-line text-sm" />
              </Link>
            </div>
          </div>

          <div className="lg:sticky lg:top-24 lg:self-start">
            <RankingList />
          </div>
        </div>
      </div>
    </section>
  );
}